import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntityRequestAddchg } from "../../entity/EntityRequestAddchg";
import { EntityRequest } from "../../entity/EntityRequest";

export class DtoRequestAddchgsGetRes extends EntityRequestAddchg {
  public request = new EntityRequest();
  
  public items: EntityRequestAddchg[]  = [];
}
